import { Container, Row, Col, Image } from "react-bootstrap";
import teaWallpaper from "../images/teaWallpaper.png";

const AboutMe = () => {
  return (
    <section className="d-flex align-items-center">
      <Container className="div__container" id="about">
        <Row className="align-items-center">
          <Col
            xs={1}
            md={3}
            className="d-flex align-items-center justify-content-center"
          >
            <Image
              alt="Cup of Mint Tea"
              data-testid="tea__image"
              className="tea__image"
              src={teaWallpaper}
            />
          </Col>
          <Col xs={9} md={8}>
            <h5 className="component__h5Title">
              <Image
                alt="Cup of Mint Tea"
                data-testid="tea__image__mobile"
                className="tea__image__mobile"
                src={teaWallpaper}
              />{" "}
              About Me
            </h5>
            <main>
              <p className="about__paragraph">
                Hi there! 👋 I'm passionate about software development and
                always have a cup of mint tea by my side when I'm working. I'm a
                great team player and love collaborating with others to solve
                challenging problems. I'm a great listener and always eager to
                learn from my colleagues. If you're looking for a committed and
                enthusiastic developer who loves mint tea, let's chat!
              </p>
            </main>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutMe;
